/**
 * @param {object} params
 * @param {import("../../types/Subscription").Subscription[]} params.subscriptions
 * @param {import("../../types/Holder").Holder[]} params.holders
 */
export function getSubscriptionsCompatibleWithHolders({
  subscriptions,
  holders,
}) {
  return subscriptions.filter((subscription) => {
    // get all holder types
    const holderTypes = holders.map((holder) => holder.type);
    // reduce the holder types to have only unique values
    const uniqueHolderTypes = holderTypes.reduce(
      (acc, curr) => (acc.includes(curr) ? acc : [...acc, curr]),
      /** @type {import("@raiden/library/types/Holder").HolderType[]} */ ([]),
    );
    // check if the subscription has any of the holder types of the holders
    return subscription.prestations_holder_types?.some(
      (subscriptionHolderType) =>
        uniqueHolderTypes.includes(subscriptionHolderType),
    );
  });
}
